import PropTypes from 'prop-types';
import React from 'react';

import IconBounds from '../IconBounds';
import { PersonCheck } from '../shapes';


const PersonCheckSvg = (props) => (
  <g>
    <IconBounds />
    <PersonCheck {...props} />
  </g>
);

PersonCheckSvg.propTypes = {
  fill: PropTypes.string,
  stroke: PropTypes.string,
  strokeWidth: PropTypes.number,
};

PersonCheckSvg.defaultProps = {
  fill: '#000',
  stroke: '#000',
  strokeWidth: 1,
};


export default PersonCheckSvg;
